module.exports = __webpack_public_path__ + "static/img/kzlc.692b05aa.png";